import { IGetGedArquivoPdfDataUseCase } from "../../../presentation/useCases/read/get_ged_arquivo_pdf_data_use_case";
import { openInBlobInBlank } from "../../../utils/view_utils";
import { ICommonsRepository } from "../../repositories/commons_repository";

export class GetGedArquivoPdfDataUseCase implements IGetGedArquivoPdfDataUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getGedArquivoPdfData(
    idArquivoModulo: number,
    nomeArquivo: string,
  ): Promise<void> {
    const blob = await this.repository.getGedArquivoPdfData(idArquivoModulo);
    if (!blob) throw new Error('Falha ao buscar dados da imagem!');
    await openInBlobInBlank(nomeArquivo, blob);
  }
}
